import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];
  static values = {
    id: Number,
    integrationId: Number,
    index: Number,
    type: String,
  };

  connect() {}

  addMapping(event) {
    event.preventDefault();
    let index = this.containerTarget.children.length;

    fetch(
      `/integrations/${this.integrationIdValue}/user_integrations/${this.idValue}/add_mapping?index=${index}&type=${this.typeValue}`,
      {
        method: "GET",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }

  removeMapping(event) {
    event.preventDefault();

    let index = this.indexValue;

    fetch(
      `/integrations/${this.integrationIdValue}/user_integrations/${this.idValue}/remove_mapping?index=${index}&type=${this.typeValue}`,
      {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
